import { z } from "zod";

export const accountProfile = z.object({
  email: z.string(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  street: z.string().nullish(),
  zipCode: z.string().nullish(),
  city: z.string().nullish(),
  phoneNumber: z.string().nullish(),
  countryCode: z.string().nullish(),
  socialSecurityNumber: z.string().nullish(),
  companyName: z.string().nullish(),
  companyOrganizationalNumber: z.string().nullish(),
  isCompany: z.boolean().nullish(),
  birthDate: z.string().nullish(),
});

export type AccountProfile = z.infer<typeof accountProfile>;
